import { forwardRef } from 'react';
import cn from 'bem-cn';

import { Link, Stack } from '../UI';
import { getCurrentYear } from '../../utils/date/date';

import { FooterProps } from './Footer.types';
import './Footer.scss';
import { FOOTER_LINKS } from './Footer.constants';

const b = cn('footer');

export const Footer = forwardRef<HTMLDivElement, FooterProps>((props, ref) => {
    const { isLightColors = false } = props;

    const year = getCurrentYear();

    return (
        <Stack as="footer" ref={ref} className={b({ 'light-colors': isLightColors })}>
            <p>© {year} Яндекс</p>
            <Stack className={b('links')}>
                {FOOTER_LINKS.map((link, index) => (
                    <Link key={`footer-link-${index}`} to={link.href} external>
                        {link.text}
                    </Link>
                ))}
            </Stack>
        </Stack>
    );
});
